import { css } from '@emotion/css';
import { LoadingState } from '@grafana/schema';
import { InlineSwitch } from '@grafana/ui';
import React from 'react';
import { sceneGraph } from '../../core/sceneGraph/index.js';
import { SceneObjectBase } from '../../core/SceneObjectBase.js';
import { ControlsLabel } from '../../utils/ControlsLabel.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class SceneDataLayerControls extends SceneObjectBase {
  constructor() {
    super({ layersMap: {} });
    this.addActivationHandler(() => this._onActivate());
  }
  _onActivate() {
    const layers = sceneGraph.getDataLayers(this, true);
    this.setState({ layersMap: layers.reduce((acc, l) => __spreadProps(__spreadValues({}, acc), { [l.state.key]: l.state.isEnabled }), {}) });
  }
  toggleLayer(l) {
    this.setState({ layersMap: __spreadProps(__spreadValues({}, this.state.layersMap), { [l.state.key]: !l.state.isEnabled }) });
    l.setState({ isEnabled: !l.state.isEnabled });
  }
}
SceneDataLayerControls.Component = SceneDataLayerControlsRenderer;
function SceneDataLayerControlsRenderer({ model }) {
  const { layersMap } = model.useState();
  const layers = sceneGraph.getDataLayers(model, true);
  if (layers.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, layers.map((l) => {
    const elementId = `data-layer-${l.state.key}`;
    if (l.state.isHidden) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(SceneDataLayerControl, {
      key: elementId,
      layer: l,
      onToggleLayer: () => model.toggleLayer(l),
      isEnabled: layersMap[l.state.key]
    });
  }));
}
function SceneDataLayerControl({ layer, isEnabled, onToggleLayer }) {
  var _a, _b;
  const elementId = `data-layer-${layer.state.key}`;
  const { data } = layer.useState();
  const showLoading = Boolean(data && data.state === LoadingState.Loading);
  return /* @__PURE__ */ React.createElement("div", {
    className: containerStyle
  }, /* @__PURE__ */ React.createElement(ControlsLabel, {
    htmlFor: elementId,
    isLoading: showLoading,
    onCancel: () => {
      var _a2;
      return (_a2 = layer.cancelQuery) == null ? void 0 : _a2.call(layer);
    },
    label: layer.state.name,
    description: layer.state.description,
    error: (_b = (_a = layer.state.data) == null ? void 0 : _a.errors) == null ? void 0 : _b[0].message
  }), /* @__PURE__ */ React.createElement(InlineSwitch, {
    id: elementId,
    value: isEnabled,
    onChange: onToggleLayer
  }));
}
const containerStyle = css({ display: "flex" });

export { SceneDataLayerControl, SceneDataLayerControls };
//# sourceMappingURL=SceneDataLayerControls.js.map
